export default "__VITE_ASSET__QcMjD3dc__"